import { StoreIcon } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/card';
import { useFetch } from '@/hooks/useFecth';
import { useClub } from '../ClubContext';
import ClubSettingsCardHeader from '../components/ClubSettingsCardHeader';
import IntegracaoAsaasClub from '../components/IntegracaoAsaasClub';
import ResaleProductsClub from '../components/ResaleProductsClub';
import TermsClub from '../components/TermsClub';

export default function ResaleClub() {
    const { data, mutate } = useFetch('club');
    const { hasBenefits, isReseller, reloadHealth } = useClub();

    const refresh = async () => {
        await mutate();
        await reloadHealth?.();
    };

    return (
        <div className="flex flex-col gap-6">
            <Card>
                <CardHeader>
                    <ClubSettingsCardHeader
                        icon={StoreIcon}
                        title="Revenda"
                        description="Produtos de revenda, termos e integração de pagamentos. O período de teste fica no cadastro de cada plano."
                    />
                </CardHeader>
            </Card>

            <div className="flex flex-col gap-4">
                {hasBenefits ? <ResaleProductsClub /> : null}
                {isReseller ? <TermsClub data={data} mutate={refresh} /> : null}
                {isReseller ? <IntegracaoAsaasClub data={data} mutate={refresh} /> : null}
            </div>
        </div>
    );
}
